import RouterAdapter from "@pathwright/auth/src/routes/RouterAdapterForLegacy"
import AuthContainer, {
  AuthContainerProps
} from "@pathwright/auth/src/views/auth/AuthContainer"
import { ConnectedSpaceProvider } from "@pathwright/auth/src/views/space/api/context"

type Props = AuthContainerProps & { useTheme?: boolean }

const RouteElement = ({ useTheme, ...props }: Props) => {
  return (
    <ConnectedSpaceProvider useTheme={useTheme}>
      <div
        className="AdaptedAuthContainer chakra-ui-reset-css"
        style={{ width: "100%" }}
      >
        <AuthContainer {...props} />
      </div>
    </ConnectedSpaceProvider>
  )
}

// Wrapping with RouterProvider in order for the `useBlocker` hook to work.
const AdaptedAuthContainer = (props: Props) => {
  return <RouterAdapter element={<RouteElement {...props} />} />
}

export default AdaptedAuthContainer
